import React from 'react';
import '../assets/css/Counters.css';

const Counters = () => {
    return (
        <section id="bg-counters" className="padding bg-counters parallax position-relative">
            <div className="overlay overlay-dark opacity-6 z-index-0"></div>
            <div className="container position-relative z-index-1">
                <div className="counter-dark-overlay">
                    <div className="row align-items-center text-center">
                        <div className="col-lg-4 col-md-4 col-sm-4 bottom10">
                            <div className="counters whitecolor top10 bottom10">
                                <span className="count_nums font-light" data-to="128965" data-speed="2500"> </span>
                            </div>
                            <h3 className="font-light whitecolor top20">Children</h3>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4">
                            <div className="counters whitecolor top10 bottom10">
                                <span className="count_nums font-light" data-to="590" data-speed="2500"> </span>
                            </div>
                            <h3 className="font-light whitecolor top20">Schools</h3>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 bottom10">
                            <div className="counters whitecolor top10 bottom10">
                                <span className="count_nums font-light" data-to="46784" data-speed="2500"> </span>
                            </div>
                            <h3 className="font-light whitecolor top20">Parents</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Counters;
